// import './CheckBox.css';
// import { setLocalStorage } from '../../../utils/localStorage';
// import { ChangeEvent } from 'react';
//
// export const CheckBox = () => {
//     const handleChangeCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
//         setLocalStorage('isChecked', e.target.checked);
//     };
//
//     return (
//         <>
//             <input onChange={(e) => handleChangeCheckbox(e)} id="checkbox" type="checkbox" className="checkbox" />
//             <label htmlFor="checkbox" className="checkbox__label-text">
//                 {}
//             </label>
//         </>
//     );
// };

import React, { ChangeEvent } from 'react';
import './CheckBox.css';
import { setLocalStorage } from '../../../utils/localStorage';

interface CheckBoxProps {
    id: string;
    label?: string;
    checked: boolean;
    onChange?: (checked: boolean) => void;
    className?: string;
}

export const CheckBox: React.FC<CheckBoxProps> = ({ id, label, checked, onChange, className }) => {
    const handleChangeCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.checked);
            setLocalStorage('isChecked', e.target.checked);
        }
    };

    return (
        <>
            <input
                id={id}
                type="checkbox"
                className={`checkbox ${className ? className : ''}`}
                onChange={(e) => handleChangeCheckbox(e)}
                checked={checked}
            />
            {label && (
                <label htmlFor={id} className={`checkbox__label-text ${className ? className : ''}`}>
                    {label && label}
                </label>
            )}
        </>
    );
};
